import SvgIcon from "@mui/material/SvgIcon";

interface ProgrammesIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function ProgrammesIcon({
  htmlColor,
  fontSize,
}: ProgrammesIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize={fontSize || "medium"}>
      <path
        d="M5.46997 9C7.40297 9 8.96997 7.433 8.96997 5.5C8.96997 3.567 7.40297 2 5.46997 2C3.53697 2 1.96997 3.567 1.96997 5.5C1.96997 7.433 3.53697 9 5.46997 9Z"
        stroke="#1C4321"
        strokeWidth="1.5"
      />
      <path
        d="M16.97 15H19.97C21.07 15 21.97 15.9 21.97 17V20C21.97 21.1 21.07 22 19.97 22H16.97C15.87 22 14.97 21.1 14.97 20V17C14.97 15.9 15.87 15 16.97 15Z"
        stroke="#1C4321"
        strokeWidth="1.5"
      />
      <path
        d="M11.9999 5H14.6799C16.5299 5 17.3899 7.29 15.9999 8.51L8.00995 15.5C6.61995 16.71 7.47994 19 9.31994 19H11.9999"
        stroke="#1C4321"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48622 5.5H5.49777"
        stroke="#1C4321"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4862 18.5H18.4978"
        stroke="#1C4321"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
